import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let ImageUploadMixin = class ImageUploadMixin extends Vue {
    filterNewImages(images) {
        const newUploads = (image) => image.isNew;
        return images.filter(newUploads);
    }
    getDeletedImageUuids(images) {
        const deleted = (image) => image.isDeleted;
        const uuid = (image) => image.uuid;
        return images.filter(deleted).map(uuid);
    }
};
ImageUploadMixin = __decorate([
    Component
], ImageUploadMixin);
export default ImageUploadMixin;
